import { createSlice } from "@reduxjs/toolkit";
import { get_schedule_task_thunk, save_schedule_task_thunk, complete_schedule_task_thunk } from './scheduleTaskThunk'

const initialState = {
    data: null,
    error: null,
    loading: false,
}

const getScheuldeTasks = (builder: any) => {
    builder.addCase(get_schedule_task_thunk.pending, (state: any) => {
        state.loading = true;
        state.error = null;
    }).addCase(get_schedule_task_thunk.fulfilled, (state: any, action: any) => {
        state.loading = false;
        state.data = action.payload.data.response
    }).addCase(get_schedule_task_thunk.rejected, (state: any, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Redux Toolkit Error'
    })
}

const saveAnswerCases = (builder: any) => {
    builder.addCase(save_schedule_task_thunk.pending, (state: any) => {
        state.loading = true;
        state.error = null;
    }).addCase(save_schedule_task_thunk.fulfilled, (state: any, action: any) => {
        state.loading = false;
    }).addCase(save_schedule_task_thunk.rejected, (state: any, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Redux Toolkit Error'
    })
}
const confirmAnswerCases = (builder: any) => {
    builder.addCase(complete_schedule_task_thunk.pending, (state: any) => {
        state.loading = true;
        state.error = null;
    }).addCase(complete_schedule_task_thunk.fulfilled, (state: any, action: any) => {
        state.loading = false;
    }).addCase(complete_schedule_task_thunk.rejected, (state: any, action: any) => {
        state.loading = false;
        state.error = action.payload || 'Redux Toolkit Error'
    })
}


const alertSlice = createSlice({
    name: "scheduleTask",
    initialState,
    reducers: {
        clearDocs: (state) => {
            state.data = null;
            state.error = null;
            state.loading = false
        },
    },
    extraReducers: (builder) => {
        getScheuldeTasks(builder)
        saveAnswerCases(builder)
        confirmAnswerCases(builder)
    }
})

export const { clearDocs } = alertSlice.actions;

export default alertSlice.reducer;
